module.exports = __webpack_public_path__ + "static/media/copy.d2386107.svg";